import useMutateBusiness from "../../hooks/useMutateBusiness";
import useGlobalParams from "../../hooks/useGlobalParams";

import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useState } from "react";
import SettingsNavigation from "./SettingsNavigation";

export default function Organization() {
  const { organizationId } = useGlobalParams();
  const { createBusiness } = useMutateBusiness();

  const [businessName, setBusinessName] = useState('');

  const onCreateBusiness = e => {
    e.preventDefault();

    const data = {
      name            : businessName,
      organization_id : organizationId,
    };

    createBusiness.mutate({ data }, { onSuccess: () => alert("LISTO!")});
  }

  return (
    <div className="__organization-settings">
      <SettingsNavigation />
      <h2>Organization</h2>

      <h3 className="mt-5">Create New Business</h3>
      <Form noValidate onSubmit={onCreateBusiness}>
        <Form.Group className='language-select my-4'>
          <Form.Label>Name</Form.Label>
          <Form.Control value={businessName} onChange={e => setBusinessName(e.target.value)} />
        </Form.Group>
        <Button type="submit" disabled={!businessName.trim()}>Create</Button>
      </Form>
    </div>
  );
}
